import React, { useContext } from "react";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import { MTableToolbar } from "material-table";

import ReportContext from "../../../../context/reports/ReportContext";

const ReportDetailsToolbar = ({ props, groupByMediaBuyer }) => {
  const [group_by_media_buyer, setGroupByMediaBuyer] = groupByMediaBuyer;

  const { report_type_aureas } = useContext(ReportContext);

  return (
    <div>
      <MTableToolbar {...props} />
      <Grid container alignItems="center" justifyContent="flex-end">
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox
                disabled={report_type_aureas === "Product Analytics"}
                color="primary"
                checked={group_by_media_buyer}
                onChange={(e) => setGroupByMediaBuyer(e.target.checked)}
              />
            }
            label="Group by Media Buyer"
          />
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default ReportDetailsToolbar;
